var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.344,
    height: 6.11,
    viewBox: "0 0 10.344 6.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -100.698)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 100.698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.178,101.209l-.339-.341a.567.567,0,0,0-.8,0l-3.865,3.865-3.87-3.87a.567.567,0,0,0-.8,0l-.339.339a.566.566,0,0,0,0,.8l4.607,4.624a.578.578,0,0,0,.4.181h0a.578.578,0,0,0,.4-.181l4.6-4.611a.574.574,0,0,0,0-.806Z",
    transform: "translate(0 -100.698)",
    fill: "#40404d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.924a54ba7b07395be12460a2f970eaad.svg";
export { ForwardRef as ReactComponent };